import { motion } from "framer-motion";
import { NumberTicker } from "@/components/ui/number-ticker";

const STATS = [
  {
    value: 30,
    direction: "up" as const,
    label: "dni contentu",
    sublabel: "gotowego do publikacji",
    delay: 0,
  },
  {
    value: 1,
    direction: "up" as const,
    label: "dzień nagrań",
    sublabel: "z naszą ekipą",
    delay: 0.2,
  },
  {
    value: 0,
    direction: "down" as const,
    startValue: 10,
    label: "godzin montażu",
    sublabel: "z Twojej strony",
    delay: 0.4,
  },
] as const;

const fadeUp = {
  hidden: { opacity: 0, y: 24 },
  visible: (i: number) => ({
    opacity: 1,
    y: 0,
    transition: { delay: i * 0.12, duration: 0.5, ease: "easeOut" as const },
  }),
};

const StatsSection = () => {
  return (
    <section className="py-20 md:py-28 relative">
      <div className="relative z-10 max-w-5xl mx-auto px-4 text-center">
        <motion.p
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, margin: "-80px" }}
          variants={fadeUp}
          custom={0}
          className="text-sm md:text-base text-gray-500 font-medium mb-12 tracking-widest uppercase"
        >
          Jeden dzień. Cały miesiąc.
        </motion.p>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-10 md:gap-6">
          {STATS.map((stat, i) => (
            <motion.div
              key={stat.label}
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true, margin: "-60px" }}
              variants={fadeUp}
              custom={i + 1}
              className="flex flex-col items-center"
            >
              <NumberTicker
                value={stat.direction === "down" ? (stat as { startValue: number }).startValue : stat.value}
                direction={stat.direction}
                delay={stat.delay}
                className="text-6xl md:text-7xl lg:text-8xl font-bold text-primary"
              />
              <span className="text-lg md:text-xl font-semibold text-gray-900 mt-3">
                {stat.label}
              </span>
              <span className="text-sm text-gray-500 mt-1">
                {stat.sublabel}
              </span>
            </motion.div>
          ))}
        </div>

        <motion.p
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, margin: "-40px" }}
          variants={fadeUp}
          custom={5}
          className="text-sm text-gray-500 mt-14 font-medium"
        >
          Ty mówisz. My robimy resztę.
        </motion.p>
      </div>
    </section>
  );
};

export default StatsSection;
